// import React from 'react';
// import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram } from 'react-icons/fa';  // Importing icons from react-icons
// import './index.css'

// const Footer = () => {
//   return (
//     <div className="footer">
//       <div className="social-icons">
//         {/* Social Media Icons */}
//         <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
//           <FaFacebook  style={{color:'white',marginRight:10}}/>
//         </a>
//         <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
//           <FaTwitter style={{color:'white', marginRight:10}}/>
//         </a>
//         <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
//           <FaLinkedin style={{color:'white', marginRight:10}}/>
//         </a>
//         <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
//           <FaInstagram style={{color:'white', marginRight:10}}/>
//         </a>
//       </div>
//       <hr class="custom-hr" />

//       <div className="copy-right">
//         <p>@2024 Emedha Technologies. All Rights Reserved.</p>
//       </div>
//     </div>
//   );
// }

// export default Footer;

import React, { useState } from 'react';
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram, FaYoutube } from 'react-icons/fa';
import './index.css';
import { Button } from 'react-bootstrap';

const Footer = () => {
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);

  const handleOpenModal = () => setShowPrivacyModal(true);
  const handleCloseModal = () => setShowPrivacyModal(false);

  const [showPrivacyModal1, setShowPrivacyModal1] = useState(false);

  const handleOpenModal1 = () => setShowPrivacyModal1(true);
  const handleCloseModal1 = () => setShowPrivacyModal1(false);

  return (
    <div className="footer">
      {/* Social Media Icons */}
      <div className="social-icons">
        <a href="https://www.facebook.com/lbnhyderabad" target="_blank" rel="noopener noreferrer">
          <FaFacebook />
        </a>
        {/* <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
          <FaTwitter />
        </a>
        <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
          <FaLinkedin />
        </a> */}
                <a href="https://www.youtube.com/@LBNMD320" target="_blank" rel="noopener noreferrer">
          <FaYoutube />
        </a>
        <a href="https://www.instagram.com/lbnhyderabad" target="_blank" rel="noopener noreferrer">
          <FaInstagram />
        </a>
      </div>

      <hr className="custom-hr" />

      {/* Footer Links */}
      <div className="footer-links">
        <p onClick={handleOpenModal}>Privacy Policy</p>|
        <p onClick={handleOpenModal1}>Disclaimer</p>
      </div>

      <div className="copy-right">
        <p>&copy; 2025 Emedha Technologies. All Rights Reserved.</p>
      </div>

      {/* Privacy Policy Modal */}
      {showPrivacyModal && (
        <div className="modal-overlay">
          <div className="modal-content text-black shadow-lg p-6 bg-white">
            <Button className="modal-close text-2xl font-bold hover:text-gray-700" style={{width:'100px'}} onClick={handleCloseModal}>&times;</Button>
            <h2 >Privacy Policy</h2>
            {/* <p ><strong>Effective Date:</strong> [Insert Date]</p> */}
            <p>
            LBN-MD 320 Business Network we respects your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our services.
            </p>


            <h3 >1. Information We Collect</h3>
            <p ><strong>Personal Information:</strong> We collect personal information such as your name, email address, phone number, LBN-MD 320 Business Network, job title, business profile, location, and payment details (if applicable).</p>
            <p ><strong>Usage Data:</strong> We collect data on how you interact with our platform, including your IP address, browser type, access times, pages viewed, and clickstream data.</p>
            <p ><strong>Referral Activity:</strong> We collect information related to your referral interactions, such as referral history, leads shared, business connections made, and success rates.</p>

            <h3 >2. How We Use Your Information</h3>
            <p >To provide and manage our services effectively.</p>
            <p >To facilitate referrals and business networking.</p>
            <p >To communicate with you about updates, promotions, and events.</p>
            <p >To process payments (if applicable).</p>
            <p >To improve and customize our services.</p>
            <p >To comply with legal obligations.</p>

            <h3 >3. Sharing of Information</h3>
            <p >We may share your information with the following parties:</p>
            <p ><strong>Other Members:</strong> To enable referrals and networking, we may share limited business contact information with other verified users.</p>
            <p ><strong>Service Providers:</strong> Third-party vendors who assist us in various operational tasks such as payment processing, hosting, and customer support.</p>
            <p ><strong>Legal Requirements:</strong> We may share your information to comply with legal obligations or to protect the rights, safety, or enforcement of our terms.</p>
            <p ><strong>We do not sell your personal information</strong> to third parties.</p>

            <h3 >4. Data Security</h3>
            <p >We implement industry-standard measures to protect your personal data from unauthorized access, use, or disclosure. However, no online platform can be 100% secure, and you use our services at your own risk.</p>

            <h3 >5. Your Rights</h3>
            <p >You can:</p>
            <p >Access and update your profile at any time.</p>
            <p >Opt out of marketing emails using the unsubscribe link.</p>
            <p >Request the deletion of your account and data, subject to legal and contractual obligations.</p>

            <h3 >6. Cookies and Tracking</h3>
            <p >We use cookies and similar technologies to enhance your experience, analyze usage, and provide relevant content. You can manage cookie settings through your browser.</p>

            <h3 >7. Third-Party Links</h3>
            <p >Our platform may contain links to third-party websites or services. We are not responsible for their privacy practices or content.</p>

            <h3 >8. Children’s Privacy</h3>
            <p >Our services are not intended for individuals under the age of 18. We do not knowingly collect data from children.</p>

            <h3 >9. International Users</h3>
            <p >If you access our services outside of India, your data may be transferred to and processed in India, where privacy laws may differ from those in your jurisdiction.</p>

            <h3 >10. Changes to This Policy</h3>
            <p >We may update this Privacy Policy from time to time. If significant changes are made, we will notify you through email or via our platform.</p>

            <h3 >11. Contact Us</h3>
            <p >If you have questions or concerns about this policy, please contact us at:</p>
            <p ><strong>Email:</strong> <a href="mailto:lbnmd320@gmail.com" className="text-blue-600 hover:underline">lbnmd320@gmail.com</a></p>
        
          </div>
        </div>

      )}


      {/* Terms of Service / Disclaimer Modal */}
      {showPrivacyModal1 && (
        <div className="modal-overlay">
          <div className="modal-content text-black shadow-lg p-6 bg-white">
            <Button className="modal-close text-2xl font-bold hover:text-gray-700" style={{width:'100px'}} onClick={handleCloseModal1}>&times;</Button>
            <h2>Disclaimer</h2>
            {/* <p><strong>Effective Date:</strong> [Insert Date]</p> */}
            <p>LBN-MD 320 Business Network we provides a platform to facilitate business referrals and networking among professionals. By using our Services, you acknowledge and agree to the following disclaimer:</p>

            <h3>1. No Guarantee of Business Outcomes</h3>
            <p>We strive to create meaningful connections, but we *do not guarantee* that referrals will result in business deals, leads, revenue, or any specific outcomes. Success depends on various factors outside our control, including your individual efforts, industry conditions, and client relationships.</p>

            <h3>2. Independent Member Conduct</h3>
            <p>Members of our network act independently. We are *not responsible* for the behavior, performance, integrity, or legitimacy of any user, member, or business connected through our platform. Always perform your own due diligence before engaging in business transactions.</p>

            <h3>3. Not Legal or Financial Advice</h3>
            <p>Information provided through our platform, events, or communications is for general networking and educational purposes only. It *does not constitute legal, financial, or professional advice.* Always consult with qualified professionals before making any business decisions.</p>

            <h3>4. Third-Party Content</h3>
            <p>Our platform may include information or links to third-party content, including websites, advertisements, or services. We do *not endorse or control* third-party content and are not liable for any loss or damage caused by your use of or reliance on such content.</p>

            <h3>5. Platform Availability</h3>
            <p>We aim to maintain uninterrupted access to our Services but do *not guarantee* that the platform will always be available, secure, or error-free. We may suspend or modify access at any time without prior notice.</p>

            <h3>6. Limitation of Liability</h3>
            <p>To the fullest extent permitted by law, LBN-MD 320 Business Network shall *not be liable* for any indirect, incidental, consequential, or special damages arising from your use of or inability to use the platform or Services.</p>

            <h3>7. Use at Your Own Risk</h3>
            <p>u use the platform and interact with other members *at your own risk.* We encourage you to take appropriate precautions and verify all information before taking action based on a referral or connection.</p>

            <h3>8. Contact Us</h3>
            <p><strong>Email:</strong> <a href="mailto:lbnmd320@gmail.com" className="text-blue-600 hover:underline">lbnmd320@gmail.com</a></p>
            {/* <p><strong>Phone:</strong> [Insert Phone Number]</p>
            <p><strong>Address:</strong> [Insert Business Address]</p> */}
          </div>
        </div>
      )}

    </div>
  );
};

export default Footer;